import pushClevertapEvent from 'clevertap/pushClevertapEvent';

export function appMarketStart() {
  pushClevertapEvent('Apps Tab Marketplace', {});
}

export function myAppStart() {
  pushClevertapEvent('Apps Tab My Apps');
}

export function devPlatform() {
  pushClevertapEvent('Apps Dev Platform');
}
